import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Badge, Spinner } from "react-bootstrap";
import { savOperations } from "state/ducks/store/sav";

/**
 * Historique des envois SMS/email SAV d'une journée
 * (clients ayant commandé ce jour-là, tous points confondus).
 * refreshKey : incrémenter pour forcer un rechargement (ex: après un envoi).
 */
const SendHistoryList = (props) => {

  const { date, refreshKey, onLoaded } = props;

  const dispatch = useDispatch();

  const [items, setItems]         = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Permet au parent d'exploiter les envois chargés (ex: alerte doublon)
  const onLoadedRef = useRef(onLoaded);
  onLoadedRef.current = onLoaded;

  useEffect(() => {
    if (!date) {
      return;
    }
    setIsLoading(true);
    dispatch(savOperations.getIntendanceSendHistory({ date: date }))
      .then((result) => {
        const loadedItems = result?.data?.result || [];
        setItems(loadedItems);
        if (onLoadedRef.current) {
          onLoadedRef.current(loadedItems);
        }
      })
      .catch(() => {
        setItems([]);
        if (onLoadedRef.current) {
          onLoadedRef.current([]);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [date, refreshKey, dispatch]);

  if (isLoading) {
    return (
      <p>
        <Spinner animation="border" size="sm" className="mr-2" />
        Chargement de l'historique...
      </p>
    );
  }

  return (
    <>
      <p className="text-muted mb-2">
        {items.length} envoi(s) ce jour.
      </p>
      {items.length === 0 &&
        <p className="text-muted">Aucun SMS ni email envoyé ce jour.</p>
      }
      {items.map((item) => (
        <div key={item.id} className="border rounded p-2 mb-1" style={{ background: "#fdfdfd" }}>
          <Badge variant={item.type === "sms" ? "primary" : "info"} className="mr-1">
            {item.type === "sms" ? "SMS" : "Email"}
          </Badge>
          <strong>
            {item.customer.firstname} {item.customer.lastname}
          </strong>
          <small className="text-muted"> — {item.date && item.date.substring(11, 16)}</small>
          <small className="d-block text-muted" style={{ whiteSpace: "pre-wrap" }}>
            {item.description}
          </small>
        </div>
      ))}
    </>
  );
};

SendHistoryList.propTypes = {
  date: PropTypes.string.isRequired,
  refreshKey: PropTypes.number,
  onLoaded: PropTypes.func,
};

SendHistoryList.defaultProps = {
  refreshKey: 0,
  onLoaded: null,
};

export default SendHistoryList;
